import { useNavigate } from "react-router";

import { useSelector, useDispatch } from "react-redux";
import { getMyCompany } from "../../../redux/reducer/getCompany/action/action";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { checkedCopmany } from "../../../redux/reducer/checkedCompany/action/action";
import { fetchUsers } from "../../../redux/reducer/postFetcReducer/action/action";
import { getCompanyForChangeAPI } from "../../../redux/reducer/myCompanyAPI/action/action";
import DeleteCompany from "../../page/addCompany/deleteCompany/delCompany";
import { getmyinfoAction } from "../../../redux/reducer/getmyinfo/action/action";
import EditCompany from "../../page/addCompany/editCompany/editcopnay";
import { checkedSessionAction } from "../../../redux/reducer/getCheckedCompanySession/action/action";
import CheckedRadioBTN from "../checkedBtn/checkedrdaio";
import ByAxios from "../../../hook/hookFetch/axios";
import "./changeCompanyLight.css"
import "./changeCompanyDark.css"

import {

    Text
} from "@chakra-ui/react";






export default function ChangeCompanyDrower() {
    const getDarkModoe = useSelector(darkModes => darkModes)
    const [isMobile, setIsMobile] = useState(false);


    const [isOpen, setIsOpen] = useState(true);
    const [selectedOption, setSelectedOption] = useState("");
    const dropdownRef = useRef(null);

    const [toggle, setToggle] = useState(true)
    const navigate = useNavigate("")
    const dispatch = useDispatch()
    const [show, setShow] = useState(false);
    const [checkedINdexCopmany, setcheckedINdexCopmany] = useState(0)
    const [value, setValue] = useState('0')

    const getAllCompany = useSelector(company => company.userReducerCompany.users)
    const getDark = useSelector(dark => dark)
    const checked = useSelector(company => company.userReducerCompanyChecked)
    const getDefaulyCheckedSession = useSelector(company => company.checkedSessionReducer)
    const getAllCompanyRed = useSelector(company => company)

    const toggleMenu = useSelector(toggleMenu => toggleMenu)


    const myinfo = useSelector(myinfo => myinfo)
    const myIDs = myinfo.getMayInfoReducer.myinfo._id
    let [data, error, loading, getData] = ByAxios("/auth/login/api")
    useEffect(() => {
        setIsOpen(false);
        getData()
    }, [])
    // console.log(getDark.useChangeDarkReducer);
    // stanum enq @nkerutyun@ @st szbanakan @nterulu hamar (bydefault)

    useEffect(() => {
        dispatch(getCompanyForChangeAPI("/changeapi/api"));
        dispatch(checkedSessionAction("/getCheckedCompanySession"));
        dispatch(fetchUsers())
        dispatch(getmyinfoAction("/registration/v2/api"))
        dispatch(getMyCompany("/mycopany/getallcompany"))


        if (getAllCompany.data) {
            dispatch(getCompanyForChangeAPI("/changeapi/api"));
            axios({
                method: 'get',
                url: '/mycopany/getallcompany',

            })
                .then(function (response) {

                    dispatch(checkedCopmany(response.data.data[0].companyId))
                    setValue("0")



                });
        }


    }, [dispatch])


    const changeCompanyID = (companyId, index) => {

        setcheckedINdexCopmany(index)

        setShow(true)
        dispatch(checkedCopmany(companyId))
        if (checked) {
            axios({
                method: 'get',
                url: `/mycopany/changechecked?checked=${companyId}`,

            }).then(rezult => {
                setShow(false)
                dispatch(getCompanyForChangeAPI("/changeapi/api"));
            }).catch(error => {
                setShow(false)
            })
        }

    }
    useEffect(() => {
        dispatch(getCompanyForChangeAPI("/changeapi/api"));
        dispatch(getMyCompany("/mycopany/getallcompany"))
        dispatch(fetchUsers())

    }, [dispatch, show])


    const handleGet = () => {
        dispatch(getCompanyForChangeAPI("/changeapi/api"));
        dispatch(getMyCompany("/mycopany/getallcompany"))
    }



    const getCompanyAndChange = () => {
        dispatch(getMyCompany("/mycopany/getallcompany"))
        dispatch(getCompanyForChangeAPI("/changeapi/api"))
    }




    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);


    // for mobile and dekstop queries for toggleBTN className
    useEffect(() => {
        const handleMediaQueryChange = (event) => {
            setIsMobile(event.matches);
        };

        // Create a media query for max-width: 617px
        const mediaQuery = window.matchMedia('(max-width: 617px)');

        // Initial check for the media query
        setIsMobile(mediaQuery.matches);

        // Add a listener for changes to the media query
        mediaQuery.addListener(handleMediaQueryChange);

        // Clean up the listener when the component unmounts
        return () => {
            mediaQuery.removeListener(handleMediaQueryChange);
        };

    }, [isMobile]);
    const svgRotate = useRef();

    useEffect(() => {
        if (isOpen === true && svgRotate.current) {
            svgRotate.current.style.transform = "rotate(180deg)";
          
        } else if (svgRotate.current) {
            svgRotate.current.style.transform = "rotate(0)";
          
        }
        if (svgRotate.current) {
            svgRotate.current.style.transition = "0.3s";
        }
    }, [isOpen]);
    
    return (
        <div ref={dropdownRef}  className={getDarkModoe.ToggleDarkModeReducer.chekced?"dropDownForChangeCompanyContDark":"dropDownForChangeCompanyContLight"} onClick={getCompanyAndChange}>
            <button className="dropdown-toggle" onClick={() => [toggleDropdown(), handleGet()]}>
                <p> {getAllCompanyRed.getMyCompanyAPIReducer.company
                    ? getAllCompanyRed.getMyCompanyAPIReducer.company.sellersname
                    : "Выберите компанию"}</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" ref={svgRotate}>
                    <path d="M18 9L12 15L6 9" stroke="#353535" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            {isOpen && (
                <ul className="dropDownForChangeCompanydropdown-menu">
                    {/* {getAllCompany.data?.map((items, index) => {
                        if (items.adminID == myIDs) {
                            if (
                                getDefaulyCheckedSession.checkedSession ==
                                items.companyId
                            ) {
                                return (
                                    <li
                                        className="rdbtn"
                                        key={index + "asd"}
                                        onClick={() =>
                                            changeCompanyID(items.companyId, index)
                                        }
                                    >
                                        <CheckedRadioBTN
                                            index={index}
                                            checked={true}
                                            key={index + "asd"}
                                        >
                                            {items.sellersname}{" "}
                                            <div className="acionsEditDel">
                                                <EditCompany items={items} />
                                                <DeleteCompany items={items} />
                                            </div>
                                        </CheckedRadioBTN>
                                    </li>
                                );
                            } else {
                                return (
                                    <li
                                        className="rdbtn"
                                        key={index + "asd"}
                                        onClick={() =>
                                            changeCompanyID(items.companyId, index)
                                        }
                                    >
                                        <CheckedRadioBTN index={index} checked={false}>
                                            {items.sellersname}

                                            <EditCompany items={items} />
                                            <DeleteCompany items={items} />
                                        </CheckedRadioBTN>
                                    </li>
                                );
                            }
                        } else {
                            if (
                                getDefaulyCheckedSession.checkedSession ==
                                items.companyId
                            ) {
                                return (
                                    <li
                                        className="rdbtn"
                                        key={index + "asd"}
                                        onClick={() =>
                                            changeCompanyID(items.companyId, index)
                                        }
                                    >
                                        <CheckedRadioBTN index={index} checked={true}>
                                            {items.sellersname}{" "}



                                        </CheckedRadioBTN>
                                    </li>
                                );
                            } else {
                                return (
                                    <li
                                        className="rdbtn"
                                        key={index + "asd"}
                                        onClick={() =>
                                            changeCompanyID(items.companyId, index)
                                        }
                                    >
                                        <CheckedRadioBTN index={index} checked={false}>
                                            {items.sellersname}

                                        </CheckedRadioBTN>
                                    </li>
                                );
                            }
                        }
                    })} */}
                    {
                        getAllCompany.data?.map((items, index) => {
                            return (
                                <label htmlFor={`${"chekedCompany"}` + index} className="lightBox" key={index} onClick={() => changeCompanyID(items.companyId, index)}>
                                    <li>
                                        <div className="Frame625952">

                                            {
                                                (getDefaulyCheckedSession.checkedSession == items.companyId) ?
                                                    <CheckedRadioBTN index={index} checked={true} />
                                                    :
                                                    <CheckedRadioBTN index={index} checked={false} />
                                            }




                                            <p>{items.sellersname}</p>
                                        </div>
                                        <div className="classNameEditDelCont">
                                            {
                                                (() => {
                                                    if (items.adminID == myIDs) {
                                                        return (
                                                            <>
                                                                <EditCompany items={items} />
                                                                <DeleteCompany items={items} />
                                                            </>
                                                        )
                                                    }
                                                })()
                                            }

                                        </div>
                                    </li>
                                </label>
                            )
                        })
                    }

                </ul>
            )}
        </div>
    )
}   